<template>
    <div>
        <div class="card">
            <div class="card-header fw-500 fs-xl">{{$t('header.summary')}}</div>
            <div class="card-body p-5">
                <h4 class="text-primary fw-400">{{$t('subMenu.salon_menu_treatment')}}</h4>
                <div class="row mb-3">
                    <div class="col-sm-12 col-md-4">
                        <span v-if="treatment.TnTreatmentImage == ''">-</span>
                        <img v-else class="img-fluid img-treatment img-thumbnail" :src="getImage(treatment.TnTreatmentImage)"/>
                    </div>
                    <div class="col-sm-12 col-md-8">
                        <h2 class="mt-2 text-secondary fw-700">{{treatment.TnTreatmentName}}</h2>
                        <h5 class="text-dark" style="text-decoration: underline">{{$t('label.details')}}</h5>
                        <p class="fw-300">
                            {{treatment.TnTreatmentDetails}}
                        </p>
                        <div class="w-100">
                            <span class="badge badge-warning">{{$t('table.value.min')}}</span>
                            <span class="ml-1 ">{{formatPrice(treatment.TnTreatmentMinPrice)}}</span>
                            <i class="ml-2 mr-2 fal fa-minus"></i>
                            <span class="badge badge-warning">{{$t('table.value.max')}}</span>
                            <span class="ml-1 ">{{formatPrice(treatment.TnTreatmentMaxPrice)}}</span>
                        </div>
                    </div>
                </div>
                <div class="border-top pt-3" v-if="therapy.length != 0">
                    <h4 class="text-primary fw-400">{{$t('subMenu.salon_menu_therapy')}}</h4>
                    <table class="table table-sm table-striped table-bordered">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key" :style="[tblHeader.key == 'item' ? {'width': '80%'} : '']">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in therapy" :key="i">
                                <td class="align-middle">
                                    {{i+1}}
                                </td>
                                <td class="align-middle">
                                    {{item.TnTherapyName}}
                                </td>
                                <td class="align-middle fw-300">
                                    {{item.TnTherapyDetails == '' ? '-' : item.TnTherapyDetails}}
                                </td>
                                <td class="align-middle">
                                    <span class="badge badge-primary">{{item.TnTherapyVoucherName}}</span>
                                </td>
                                <td class="align-middle">
                                    {{formatPrice(item.TnTherapyUnitPrice)}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="border-top pt-3 mt-3 mb-3">
            <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mb-2 mr-3" @click="returnTreatment">{{$t('button_link.cancel')}}</button>
            <button type="button" class="btn border-0 btn-dark btn-padding waves-effect waves-themed mb-2 mr-3" @click="previous">{{$t('button_link.prev')}}</button>
            <button type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed mb-2" @click="submitTreatmentTherapy">{{$t('button_link.done')}}</button>
        </div>
    </div>
</template>
<script>
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
export default {
    name: 'treatmentTherapySummary',
    data(){
        return{
            treatment: {}, therapy: []
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: '#', thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TnTherapyName", label: this.$i18n.t('subMenu.salon_menu_therapy'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TnTreatmentDetails", label: this.$i18n.t('label.details'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "TnTherapyVoucherName", label: this.$i18n.t('table.header.voucher'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "TnTherapyUnitPrice", label: this.$i18n.t('label.unit_price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
            ]
        }
    },
    methods:{
        getImage(img){
            return img
        },
        formatPrice(price){
            return formatPrice(price);
        },
        setSummary(treatment, therapy){
            this.treatment = treatment
            this.therapy = therapy
        },
        returnTreatment(){
            this.$emit('returnTreatment')
        },
        previous(){
            this.$emit('previous', 3)
        },
        submitTreatmentTherapy(){
            this.$emit('submitTreatmentTherapy')
        },
    }
}
</script>
<style scoped>
.img-treatment{
    width: 15em;
}
</style>